module.exports = __webpack_public_path__ + "img/myopia.96f56956.svg";